import { render, staticRenderFns } from "./ManageUserGroupsDeactivateModal.vue?vue&type=template&id=5b10a013&scoped=true&"
import script from "./ManageUserGroupsDeactivateModal.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroupsDeactivateModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserGroupsDeactivateModal.vue?vue&type=style&index=0&id=5b10a013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10a013",
  null
  
)

export default component.exports